(() => {
  const menu = document.querySelector('[data-global-menu]');
  const toggle = document.querySelector('[data-global-menu-open]');
  const close = menu?.querySelector('[data-global-menu-close]');
  const scrim = document.querySelector('[data-global-menu-scrim]');
  const setOpen = (open, restoreFocus = true) => {
    if (!menu || !toggle) return;
    menu.classList.toggle('is-open', open);
    scrim?.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    menu.inert = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('poptex-shared-menu-open', open);
    if (open) close?.focus();
    else if (restoreFocus) toggle.focus({ preventScroll: true });
  };
  toggle?.addEventListener('click', () => setOpen(!menu.classList.contains('is-open')));
  close?.addEventListener('click', () => setOpen(false));
  scrim?.addEventListener('click', () => setOpen(false));
  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setOpen(false, false)));
  window.addEventListener('pageshow', () => setOpen(false, false));
  window.matchMedia('(max-width: 760px)').addEventListener('change', e => { if (!e.matches) setOpen(false, false); });
  document.addEventListener('keydown', event => {
    if (event.defaultPrevented) return;
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) { setOpen(false); return; }
    if (event.key !== 'Tab') return;
    const openDrawer = document.querySelector('.poptex-drawer.is-open');
    if (!openDrawer) return;
    const items = [...openDrawer.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled && el.getClientRects().length);
    if (!items.length) return;
    if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
  });
})();
